export enum GoogleAnalyticsCheckoutTypes {
  ShoppingCart = 1,
  ShippingAddress = 2,
  ShippingOptions = 3,
  Payment = 4,
  Review = 5,
  Confirmation = 6,
}
